export const componentCardsProps = {
  basename: "/plataforma/inicio",
};
